import PlainPaging, { type PlainPagingProps } from './plain-paging'


export default PlainPaging
export type { PlainPagingProps }
